import React, { useEffect, useState } from 'react';
import { Box, Typography, Tab } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { TabContext, TabPanel } from '@mui/lab';
import { useSelector } from 'react-redux';
import { Root, StyledTabList, classes } from './utils';
import BillingInfo from './billing-info/BillingInfo';
import ScanHistory from './scan-history/ScanHistory';
import Members from './members/Members';
import AgGrid from '../common-components/common-ag-grid/AgGrid';
import billingHistoryRowData from './billing-info/billingHistoryRowData';
import billingHistoryColumnDef from './billing-info/billingHistoryColumnDef';
import ActivityHistoryColumnDef from './activity-history/activityHistoryColumnDef';
import { getLocalStorageItem } from '../../../services/localStorageUtils';
import { ACCOUNT_INFO } from '../../../constants/staticContent';
import {
  getActivityHistory,
  getAdminDetails,
  getSubscriptionDetails,
} from '../../../services/userApi';
import { getGridFilterSortStatus } from '../../../services/allInvoiceApi';
import ROLES from '../../../constants/roles';
import MyAccount from './my-account/MyAccount';
import ExportReport from './scan-history/ExportReport';
import { getPaymentHistoryDetails } from '../../../services/paymentsApi';
import CreditsHistory from './credit-history/CreditsHistory';

const AccountInfoTabSection = () => {
  const [value, setValue] = useState('');
  const [adminDetails, setAdminDetails] = useState('');
  const [organizationPaymentDetails, setOrganizationPaymentDetails] =
    useState('');
  const [adminOrganizationName, setAdminOrganizationName] = useState('');
  const [adminData, setAdminData] = useState('');
  const [subscriptionDetails, setSubscriptionDetails] = useState('');
  const [refreshGrid, setRefreshGrid] = useState(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const organizationId = searchParams.get('organizationId');
  const [gridSettingData, setGridSettingData] = useState({});
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);

  const loginRole = getLocalStorageItem('role');

  const getTabRoute = (tabValue) => {
    switch (tabValue) {
      case '1':
        return 'myAccount';
      case '2':
        return 'billingInfo';
      case '3':
        return 'activityHistory';
      case '4':
        return 'creditsHistory';
      case '5':
        return 'scanHistory';
      case '6':
        return 'exportReport';
      case '7':
        return 'members';
      default:
        return '';
    }
  };

  const getTabValue = (tabName) => {
    switch (tabName) {
      case 'myAccount':
        return '1';
      case 'billingInfo':
        return '2';
      case 'activityHistory':
        return '3';
      case 'creditsHistory':
        return '4';
      case 'scanHistory':
        return '5';
      case 'exportReport':
        return '6';
      case 'members':
        return '7';
      default:
        return null;
    }
  };

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const tabParam = urlSearchParams.get('tab');
    const tabValue = getTabValue(tabParam);
    const isValidTabValue =
      tabValue && ['1', '2', '3', '4', '5', '6', '7'].includes(tabValue);

    if (!isValidTabValue) {
      setValue('1');
      navigate('?tab=myAccount');
    } else {
      setValue(tabValue);
    }
  }, []);

  const getAdminDetailsFromOrganizationId = async () => {
    try {
      const response = await getAdminDetails(organizationId);
      setAdminDetails(response[0]?.billing_infos);
      setOrganizationPaymentDetails(response[0]?.payment[0]?.payment_date);
      setAdminOrganizationName(response[0]?.name);
      setAdminData(response);
    } catch (err) {
      return err;
    }
  };

  const getSubscriptionFromOrganizationId = async () => {
    try {
      if (loginRole === ROLES.ADMIN) {
        const response = await getSubscriptionDetails(user?.organization_id);
        setSubscriptionDetails(response);
      } else {
        const response = await getSubscriptionDetails(organizationId);
        setSubscriptionDetails(response);
      }
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    if (loginRole === ROLES.SUPER_ADMIN || loginRole === ROLES.SUPER_MANAGER) {
      getAdminDetailsFromOrganizationId();
    }
  }, []);
  useEffect(() => {
    if (user?.organization_id && ROLES.ADMIN) {
      getSubscriptionFromOrganizationId();
    }
  }, [user?.organization_id]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const tabName = getTabRoute(newValue);
    if (loginRole === ROLES.SUPER_ADMIN || loginRole === ROLES.SUPER_MANAGER) {
      navigate(`?tab=${tabName}&organizationId=${organizationId}`);
    } else {
      navigate(`?tab=${tabName}`);
    }
  };

  const BillingHistoryData = async (abc, xyz, efg, data) => {
    try {
      return await data;
    } catch (err) {
      return err;
    }
  };

  const getFilterSortData = async () => {
    try {
      const response = await getGridFilterSortStatus('log-history');
      setGridSettingData(response);
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    getFilterSortData();
  }, []);

  // const heading = (loginRole === ROLES.SUPER_ADMIN
  //   || loginRole === ROLES.SUPER_MANAGER)
  //   ? adminOrganizationName
  //   : null;

  const getTabClassName = (values, selectedValue) =>
    values === selectedValue ? classes.selectedTab : classes.tabList;

  let tabScanHistoryHeading = null;
  if (loginRole === ROLES.SUPER_ADMIN || loginRole === ROLES.SUPER_MANAGER) {
    tabScanHistoryHeading = ACCOUNT_INFO.SUPER_ADMIN_SCAN_HISTORY.HEADING;
  } else {
    tabScanHistoryHeading = ACCOUNT_INFO.SCAN_HISTORY.HEADING;
  }
  const getRowData = async (
    sortModel,
    searchValues,
    filterModel,
    filterValue,
    data,
    page,
  ) => {
    try {
      const PAGE_LIMIT = 25;
      const query = {};
      if (Object.keys(filterModel).length > 0) {
        Object.keys(filterModel).forEach((key) => {
          if (key === 'timestamp' && filterModel[key]) {
            if (filterModel[key].dateFrom) {
              query.timestamp_from = filterModel[key].dateFrom;
            }
            if (filterModel[key].dateTo) {
              query.timestamp_to = filterModel[key].dateTo;
            }
          } else if (filterModel[key] && filterModel[key].filter) {
            query[key] = filterModel[key].filter;
          }
        });
      }

      if (typeof data === 'string') {
        query['organizationId'] = data;
        if (loginRole === ROLES.ADMIN) {
          query['role'] = ['ADMIN', 'MANAGER', 'MEMBER'];
        } else if (loginRole === ROLES.SUPER_ADMIN) {
          query['role'] = ['SUPER_ADMIN', 'SUPER_MANAGER'];
        } else if (loginRole === ROLES.SUPER_MANAGER) {
          query['role'] = ['SUPER_MANAGER'];
        }
      }

      if (Object.keys(data ?? {}).length > 0 && typeof data !== 'string') {
        Object.keys(data).forEach((key) => {
          if (Array.isArray(data[key]) && data[key].length > 0) {
            query[key] = data[key].map((ele) => ele.value);
          } else if (loginRole === ROLES.ADMIN) {
            query[key] = ['ADMIN', 'MANAGER', 'MEMBER'];
          } else if (loginRole === ROLES.SUPER_ADMIN) {
            query[key] = ['SUPER_ADMIN', 'SUPER_MANAGER'];
          } else if (loginRole === ROLES.SUPER_MANAGER) {
            query[key] = ['SUPER_MANAGER'];
          }
        });
      }

      const payload = {
        sortType:
          Array.isArray(sortModel) && sortModel.length > 0
            ? sortModel[0].sort
            : '',
        sortOn:
          Array.isArray(sortModel) && sortModel.length > 0
            ? sortModel[0].colId
            : '',
        query,
        page,
        limit: PAGE_LIMIT,
      };
      const result = await getActivityHistory(payload);
      return result;
    } catch (error) {
      return error;
    }
  };
  return (
    <Root className={classes.root}>
      {value !== '' ? (
        <>
          {/* {loginRole === ROLES.ADMIN || loginRole === ROLES.SUPER_ADMIN ? (
            <Grid container>
              <Grid item xs={12} className={classes.tabSectionHeaderGrid}>
                <Typography
                  variant="h4"
                  className={classes.accountInfoMainHeading}
                >
                  {heading}
                </Typography>
                {loginRole === ROLES.ADMIN && (
                <Button variant="contained" className={classes.paymentButton}>
                  <Typography
                    variant="body1"
                    color={lightPalette.secondaryWhite.main}
                  >
                    {ACCOUNT_INFO.PAYMENT_BUTTON}
                  </Typography>
                </Button>
           )}
              </Grid>
            </Grid>
        ) : null} */}
          <Box>
            <TabContext value={value}>
              <Box className={classes.tabsBox}>
                <StyledTabList
                  variant="scrollable"
                  scrollButtons="auto"
                  onChange={handleChange}
                  aria-label="lab API tabs"
                >
                  {(loginRole === ROLES.MANAGER ||
                    loginRole === ROLES.ADMIN ||
                    loginRole === ROLES.MEMBER) && (
                    <Tab
                      className={classes.tabs}
                      value="1"
                      label={
                        <Typography
                          variant="subtitle1"
                          className={getTabClassName(value, '1')}
                        >
                          {ACCOUNT_INFO.MY_ACCOUNT.HEADING}
                        </Typography>
                      }
                    />
                  )}
                  {(loginRole === ROLES.MANAGER ||
                    loginRole === ROLES.ADMIN ||
                    loginRole === ROLES.SUPER_MANAGER ||
                    loginRole === ROLES.SUPER_ADMIN) && (
                    <Tab
                      className={classes.tabs}
                      value="2"
                      label={
                        <Typography
                          variant="subtitle1"
                          className={getTabClassName(value, '2')}
                        >
                          {ACCOUNT_INFO.BILLING_INFO.HEADING}
                        </Typography>
                      }
                    />
                  )}
                  <Tab
                    className={classes.tabs}
                    label={
                      <Typography
                        variant="subtitle1"
                        className={getTabClassName(value, '3')}
                      >
                        {ACCOUNT_INFO.ACTIVITY_HISTORY.HEADING}
                      </Typography>
                    }
                    value="3"
                  />
                  <Tab
                    className={classes.tabs}
                    label={
                      <Typography
                        variant="subtitle1"
                        className={getTabClassName(value, '4')}
                      >
                        {ACCOUNT_INFO.CREDITS_HISTORY.HEADING}
                      </Typography>
                    }
                    value="4"
                  />
                  <Tab
                    className={classes.tabs}
                    label={
                      <Typography
                        variant="subtitle1"
                        className={getTabClassName(value, '5')}
                      >
                        {tabScanHistoryHeading}
                      </Typography>
                    }
                    value="5"
                  />
                  <Tab
                    className={classes.tabs}
                    label={
                      <Typography
                        variant="subtitle1"
                        className={getTabClassName(value, '6')}
                      >
                        {ACCOUNT_INFO.EXPORT_REPORT.HEADING}
                      </Typography>
                    }
                    value="6"
                  />
                  <Tab
                    className={classes.tabs}
                    label={
                      <Typography
                        variant="subtitle1"
                        className={getTabClassName(value, '7')}
                      >
                        {ACCOUNT_INFO.MEMBERS.HEADING}
                      </Typography>
                    }
                    value="7"
                  />
                </StyledTabList>
              </Box>
              <TabPanel className={classes.tabPanel} value="1">
                <MyAccount
                  functionData={billingHistoryRowData}
                  getRowData={BillingHistoryData}
                  columnData={billingHistoryColumnDef}
                  subscriptionDetails={subscriptionDetails}
                />
              </TabPanel>
              <TabPanel className={classes.tabPanel} value="2">
                <BillingInfo
                  functionData={
                    loginRole === ROLES.ADMIN
                      ? user?.organization_id
                      : organizationId
                  }
                  getRowData={getPaymentHistoryDetails}
                  columnData={billingHistoryColumnDef}
                  adminDetails={adminDetails}
                  adminOrganizationName={adminOrganizationName}
                  organizationPaymentDetails={organizationPaymentDetails}
                  adminData={adminData}
                  subscriptionDetails={subscriptionDetails}
                  getSubscriptionFromOrganizationId={
                    getSubscriptionFromOrganizationId
                  }
                  getAdminDetailsFromOrganizationId={
                    getAdminDetailsFromOrganizationId
                  }
                  refreshGrid={refreshGrid}
                  setRefreshGrid={setRefreshGrid}
                />
              </TabPanel>
              <TabPanel className={classes.tabPanel} value="3">
                <AgGrid
                  TitleHeader="Activity history"
                  className={classes.activityHistoryAgGridStyle}
                  columnData={ActivityHistoryColumnDef}
                  getRowData={getRowData}
                  gridSettingData={gridSettingData}
                  gridKey="log-history"
                  functionData={user?.organization_id}
                  setGridSettingData={setGridSettingData}
                />
              </TabPanel>
              <TabPanel className={classes.tabPanel} value="4">
                <CreditsHistory organizationId={organizationId} />
              </TabPanel>
              <TabPanel className={classes.tabPanel} value="5">
                <ScanHistory organizationId={organizationId} />
              </TabPanel>
              <TabPanel className={classes.tabPanel} value="6">
                <ExportReport organizationId={organizationId} />
              </TabPanel>
              <TabPanel className={classes.tabPanel} value="7">
                <Members organizationId={organizationId} />
              </TabPanel>
            </TabContext>
          </Box>
        </>
      ) : null}
    </Root>
  );
};

export default AccountInfoTabSection;
